<template>
  <div class="custom-page" @click="emojiDialog = false">
    <div class="d-flex mt-2 px-4 align-center justify-space-between">

      <ib-btn class="primary" :small="$vuetify.breakpoint.sm || $vuetify.breakpoint.xs" @click="filter_sheet = true">
        <v-icon left>mdi-filter-outline</v-icon>
        Buscar ou filtrar
      </ib-btn>

      <v-spacer></v-spacer>
      <ib-btn class="primary mr-2" :small="$vuetify.breakpoint.sm || $vuetify.breakpoint.xs" @click="startNewConversationDialog">
        <v-icon left>mdi-plus</v-icon>
        Nova conversa
      </ib-btn>


      <v-menu offset-y>
        <template #activator="{ on }">
          <v-btn class="primary" dark icon :small="$vuetify.breakpoint.sm || $vuetify.breakpoint.xs" v-on="on">
            <v-icon>mdi-cog-outline</v-icon>
          </v-btn>
        </template>

        <v-list>
          <v-list-item class="cursor-pointer" @click="toggleNotificationSoundConfig(currentUser.config?.disable_notification_sound)">
            <v-list-item-title>
              <v-icon size="25" class="mr-1" color="primary">
                mdi-volume-high
              </v-icon>
              {{ currentUser.config?.disable_notification_sound ? 'Ativar notificações' : 'Desativar notificações' }}
            </v-list-item-title>
          </v-list-item>

          <v-list-item class="cursor-pointer" @click="dialogFinishConversations = true" v-if="currentUser.user_role === 'owner'">
            <v-list-item-title>
              <v-icon size="25" class="mr-1" color="primary">
                mdi-forum-remove-outline
              </v-icon>
              Finalizar em massa
            </v-list-item-title>
          </v-list-item>

          <v-list-item class="cursor-pointer" @click="dialogTransferDepartmentConversations = true" v-if="currentUser.user_role === 'owner'">
            <v-list-item-title>
              <v-icon size="25" class="mr-1" color="primary">
                mdi-briefcase-arrow-left-right-outline
              </v-icon>
              Transferir departamento em massa
            </v-list-item-title>
          </v-list-item>

          <v-list-item class="cursor-pointer" @click="dialogAddTagConversations = true" v-if="currentUser.user_role === 'owner'">
            <v-list-item-title>
              <v-icon size="25" class="mr-1" color="primary">
                mdi-tag-plus-outline
              </v-icon>
              Gerenciar tag em massa
            </v-list-item-title>
          </v-list-item>

          <v-list-item class="cursor-pointer" @click="toggleUserSignature">
            <v-list-item-title>
              <v-icon size="25" class="mr-1" color="primary">
                mdi-pen
              </v-icon>
              {{ currentUser.config?.user_signature ? 'Desativar assinatura' : 'Ativar assinatura' }}
            </v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>


    </div>

    <v-row style="margin: 0;">
      <v-col cols="12" lg="5" md="5" sm="12" class="pa-0">
        <div class="mx-4 mb-4">
          <v-expansion-panels class="nd-border mt-1" flat v-if="can_clear">
            <v-expansion-panel>
              <v-expansion-panel-header style="font-weight: 500;">Existem filtros ativos <span class="ml-1">({{ totalObjects }} {{ totalObjects === 1 ? 'conversa' : 'conversas' }})</span></v-expansion-panel-header>
              <v-expansion-panel-content class="py-1">
                <div class="filter-bar">
                  <div class="filter-item one-line">
                    <b>Atendimento:</b> <span>{{ getSelectedTypes }}</span>
                  </div>
                  <div class="filter-item one-line">
                    <b>Departamentos:</b> <span>{{ getSelectedDepartments }}</span>
                  </div>
                  <div class="filter-item one-line">
                    <b>Tags:</b> <span>{{ getSelectedTags }}</span>
                  </div>
                  <div class="filter-item one-line">
                    <b>Chips:</b> <span>{{ getSelectedChips }}</span>
                  </div>
                  <div v-if="pre_filter.date && pre_filter.date.length > 0" class="filter-item one-line">
                    <b>Período:</b> <span>{{ getSelectedDateRange }}</span>
                  </div>
                  <div v-if="pre_filter?.situation?.id === 'waiting_response'" class="filter-item one-line">
                    <v-chip x-small label class="error lighten-1">
                      Apenas não respondidas
                    </v-chip>
                  </div>
                  <div class="filter-item mb-1" style="display: flex; width: 100%;">
                    <v-spacer />
                    <ib-btn v-if="can_clear" small dark outlined color="error" class="mr-4" @click="clearFilters">
                      <v-icon left>mdi-filter-remove-outline</v-icon>
                      Limpar filtros
                    </ib-btn>
                  </div>
                </div>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </div>

        <v-list>
          <v-list-item-group color="primary">
            <v-list-item v-if="!loading && objects.length == 0" key="9999999" class="px-5" style="width: 100%;">
              <v-list-item-content>
                <v-list-item-title style="font-weight: 500;" class="mb-2">
                  Sem conversas...
                </v-list-item-title>
                Tente utilizar outro filtro ou aguarde por novas mensagens
              </v-list-item-content>
            </v-list-item>

            <v-virtual-scroll class="v-scroll" :items="objectsWithLoadMore" item-height="145" :bench="2">
              <template v-slot:default="{ item }">

                <div v-if="item.isLoadMoreButton" class="d-flex align-center justify-center mt-2">
                  <ib-btn v-if="button_load_more" class="mt-4" color="primary" @click="options.limit += 15; getConversations(options, false)">
                    Carregar mais
                  </ib-btn>
                </div>


                <v-list-item v-else :key="item?._id" class="cursor-pointer px-5" @click="getMessages(item)">
                  <v-list-item-avatar size="60">
                    <ib-user-avatar :user="item.contact" size="60" color="gray75" rounded />
                  </v-list-item-avatar>

                  <v-list-item-content>
                    <div class="container-name-date">
                      <v-list-item-title id="conversation-contact-name">
                        <template v-if="hasValidAutoFollowUp(item)">
                          <v-tooltip top>
                            <template v-slot:activator="{ on, attrs }">
                              <v-icon size="18" color="gray400" v-bind="attrs" v-on="on">mdi-timer-sand</v-icon>
                            </template>
                            <span>Conversa com follow-up automático</span>
                          </v-tooltip>
                        </template>

                        <template v-if="item.waiting_response">
                          <v-tooltip top>
                            <template v-slot:activator="{ on, attrs }">
                              <v-icon size="18" color="error lighten-1" class="response-badge" v-bind="attrs" v-on="on">
                                mdi-message-text-clock-outline
                              </v-icon>
                            </template>
                            <span>Conversa aguardando resposta</span>
                          </v-tooltip>
                        </template>

                        {{ item.contact?.override_name || item.contact?.name || 'Sem nome' }}

                        <v-chip v-if="item.is_manual && item.is_new" small color="primary" class="mr-1">
                          Nova
                        </v-chip>
                      </v-list-item-title>

                      <div class="d-flex align-center justify-center">

                        <v-list-item-subtitle v-if="item.context_window" class="mr-2">
                          <context-window-timer :deadline="item.context_window"></context-window-timer>
                        </v-list-item-subtitle>

                        <v-list-item-subtitle id="date-last-message">{{ $date.smallFormat(item.last_message?.created) || '' }}</v-list-item-subtitle>
                      </div>
                    </div>

                    <message-preview class="my-2" :message="item.last_message?.message" :status="item.last_message?.status" :origin="item.last_message?.origin" :type="item.last_message?.type" />

                    <v-list-item-title>
                      <template v-if="item.contact?.tags && item.contact.tags.length">
                        <ib-chip v-for="(tag, index_tag) in filteredTags(item.contact.tags)" :key="`tag_${item._id}_${index_tag}`" small class="mr-1" :color="tags_dictionary[tag]?.color">
                          {{ tags_dictionary[tag]?.name }}
                        </ib-chip>
                      </template>

                      <div class="d-flex mt-2" style="overflow: hidden; flex-wrap: nowrap; gap: 4px;">
                        <ib-chip v-if="item.chip" :color="item.channel_type === 'whatsapp_api_oficial' ? $vuetify.theme.themes.light.primary : $vuetify.theme.themes.light.info" small style="min-width: 0; overflow: hidden;">
                          <v-icon small left>mdi-whatsapp</v-icon>
                          <span style="overflow: hidden; text-overflow: ellipsis; white-space: nowrap;">{{ item.chip.name }}</span>
                        </ib-chip>

                        <ib-chip v-if="item.department" :tonal="!$isDark" :color="$isDark ? '#4b4d52' : $vuetify.theme.themes.light.gray400" small style="min-width: 0; overflow: hidden;">
                          <v-icon small left>mdi-briefcase-outline</v-icon>
                          <span style="overflow: hidden; text-overflow: ellipsis; white-space: nowrap;">{{ item.department.name }}</span>
                        </ib-chip>

                        <ib-chip v-if="!item.is_manual" small :color="$vuetify.theme.themes.light.primary" style="flex-shrink: 0;" :title="item.chatbot_type == 'flow_chatbot' ? 'Flow chatbot' : 'Chatbot'">
                          <v-icon small :left="$vuetify.breakpoint.smAndUp">
                            {{ item.chatbot_type == 'flow_chatbot' ? 'mdi-sitemap-outline' : 'mdi-robot-outline' }}
                          </v-icon>
                          <span v-if="$vuetify.breakpoint.smAndUp">{{ item.chatbot_type == 'flow_chatbot' ? 'Fluxo' : 'Chatbot' }}</span>
                        </ib-chip>

                        <ib-chip v-if="item.is_manual" small :color="$vuetify.theme.themes.light.warning" style="flex-shrink: 0;" title="Humano">
                          <v-icon small :left="$vuetify.breakpoint.smAndUp">
                            mdi-face-agent
                          </v-icon>
                          <span v-if="$vuetify.breakpoint.smAndUp">Humano</span>
                        </ib-chip>
                      </div>
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </template>
            </v-virtual-scroll>
          </v-list-item-group>
        </v-list>


      </v-col>

      <dialog-or-column v-model="showConversation" class="d-flex flex-column messages-background">
        <div class="messages-app-bar nd-border px-4 flex-grow-0" v-show="selectedConversation?._id" height="120">
          <v-btn v-if="isMobile" icon large class="mr-1" @click="showConversation = false">
            <v-icon>mdi-arrow-left</v-icon>
          </v-btn>

          <ib-user-avatar class="my-2 cursor-pointer" v-if="selectedConversation?.contact" :user="selectedConversation?.contact" size="60" color="gray75" @click="openContact(selectedConversation?.contact?._id)" />

          <div class="contact-info cursor-pointer">
            <span class="contact-name">
              <v-icon v-if="selectedConversation.waiting_response" size="20" color="error lighten-1" class="response-badge mr-1">mdi-message-text-clock-outline</v-icon>
              <span @click="openContact(selectedConversation?.contact?._id)">
                {{ selectedConversation?.contact?.override_name || selectedConversation?.contact?.name || "Contato" }}
                <small v-if="selectedConversation?.is_manual">(Atendimento humano)</small></span>
              <ib-chip v-if="selectedConversation.department" class="ml-2 cursor-pointer" :color="$vuetify.theme.themes.light.gray400" small @click="transfer_department = null; departmentDialog = true"><v-icon small left>mdi-briefcase-outline</v-icon>{{
                selectedConversation.department.name }}</ib-chip>
            </span>
            <div v-if="selectedConversation.tags?.length > 0">
              <ib-chip v-for="(tag, index_tag) in selectedConversation.tags" v-show="tags_dictionary[tag]" :key="`tag_${index_tag}`" x-small class="mr-1" :color="tags_dictionary[tag]?.color">
                {{ tags_dictionary[tag]?.name }}
              </ib-chip>
            </div>
            <span class="contact-phone" @click="openContact(selectedConversation?.contact?._id)">
              {{ typing ? 'Digitando...' : $utils.formatPhone(selectedConversation?.contact?.phone) }}
            </span>
          </div>

          <v-spacer />

          <v-menu v-if="selectedConversation?._id" offset-y>
            <template #activator="{ on }">
              <v-btn icon color="gray500" v-on="on">
                <v-icon>mdi-dots-vertical</v-icon>
              </v-btn>
            </template>

            <v-list>
              <v-list-item class="cursor-pointer" @click="openContact(selectedConversation?.contact?._id)">
                <v-list-item-title>
                  <v-icon size="25" class="mr-1" color="primary">
                    mdi-account-details-outline
                  </v-icon>
                  Dados do contato
                </v-list-item-title>
              </v-list-item>

              <v-list-item class="cursor-pointer" @click="dialogEditContactName = true">
                <v-list-item-title>
                  <v-icon size="25" class="mr-1" color="primary">
                    mdi-file-edit-outline
                  </v-icon>
                  Editar nome do contato
                </v-list-item-title>
              </v-list-item>

              <v-list-item class="cursor-pointer" @click="selectedConversation.waiting_response = false; changeConversationData()">
                <v-list-item-title>
                  <v-icon size="25" class="mr-1" color="primary">
                    mdi-check-circle-outline
                  </v-icon>
                  Marcar como respondida
                </v-list-item-title>
              </v-list-item>

              <v-list-item v-if="selectedConversation.channel_type === 'whatsapp_api_oficial' && isContextWindowExpired" class="cursor-pointer" @click="openSendTemplateDialog">
                <v-list-item-title>
                  <v-icon size="25" class="mr-1" color="primary">
                    mdi-send-variant-outline
                  </v-icon>
                  Enviar template (API Oficial)
                </v-list-item-title>
              </v-list-item>

              <v-list-item class="cursor-pointer" @click="dialogScheduledMessage = true">
                <v-list-item-title>
                  <v-icon size="25" class="mr-1" color="primary">
                    mdi-calendar-clock-outline
                  </v-icon>
                  Agendar mensagem
                </v-list-item-title>
              </v-list-item>

              <v-list-item class="cursor-pointer" @click="tagsDialog = true">
                <v-list-item-title>
                  <v-icon size="25" class="mr-1" color="primary">
                    mdi-tag-multiple-outline
                  </v-icon>
                  Atribuir tags
                </v-list-item-title>
              </v-list-item>

              <v-list-item class="cursor-pointer" @click="openTransferDialog">
                <v-list-item-title>
                  <v-icon size="25" class="mr-1" color="primary">
                    mdi-arrow-right
                  </v-icon>
                  Transferência
                </v-list-item-title>
              </v-list-item>

              <v-list-item class="cursor-pointer" @click="openCreateOpportunityFromConversation">
                <v-list-item-title>
                  <v-icon size="25" class="mr-1" color="primary">
                    mdi-filter-variant
                  </v-icon>
                  Criar oportunidade
                </v-list-item-title>
              </v-list-item>

              <v-list-item v-if="selectedConversation.finished" class="cursor-pointer" @click.native="resumeConversation(selectedConversation)">
                <v-list-item-title>
                  Retomar atendimento
                </v-list-item-title>
              </v-list-item>

              <v-list-item v-if="!selectedConversation.is_manual && !selectedConversation.finished" class="cursor-pointer" @click="setManual(selectedConversation)">
                <v-list-item-title>
                  <v-icon size="25" class="mr-1" color="primary">
                    mdi-human-greeting
                  </v-icon>
                  Atender como humano
                </v-list-item-title>
              </v-list-item>

              <v-list-item v-if="selectedConversation.auto_follow_up" @click="deleteAutoFollowUpDialog = true">
                <v-list-item-title>
                  <v-icon size="25" class="mr-1" color="primary">
                    mdi-timer-sand
                  </v-icon>
                  Desativar follow-up automático
                </v-list-item-title>
              </v-list-item>

              <v-list-item v-if="!selectedConversation.finished" class="cursor-pointer" @click="finishConversation(selectedConversation)">
                <v-list-item-title>
                  <v-icon size="25" class="mr-1" color="primary">
                    mdi-check-outline
                  </v-icon>
                  Finalizar atendimento
                </v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </div>

        <div class="conversation-container flex-grow-1">
          <div ref="dialogRef" :class="`messages-container flex-grow-1 pa-4 ${replyingMessage ? 'has-reply-preview' : ''}`">

            <div class="d-flex justify-center">
              <ib-btn v-if="rendered_messages.length < messages.length" class="mb-4" small color="primary" @click="loadMoreMessages">
                Carregar mais
              </ib-btn>
            </div>

            <div v-for="(item, message_index) in rendered_messages" :id="`message_${message_index}`" :key="`message_${message_index}`" :class="`container-chat-item ${item.origin == 'customer' ? 'container-customer' : 'container-chatbot'}-message`">
              <div :class="`fade chat-item ${item.origin == 'customer' ? 'customer' : 'chatbot'}-message ${item.deleted ? 'deleted-message' : ''} ${item.type === 'summary' ? 'summary-message' : ''} ${item.type === 'system' ? 'system-message' : ''}`" @click="selectedChatItem = item">
                <div v-if="item.deleted" style="font-size: 12px" class="mb-2">
                  <i>(Essa mensagem foi apagada)</i>
                </div>

                <div v-if="item.reply_message?.type || item.reply_message?.forwarded" class="reply-container">
                  <v-icon small>
                    mdi-reply-outline
                  </v-icon>

                  <span v-if="item.reply_message.forwarded" class="ml-1">Encaminhada</span>

                  <span v-if="item.reply_message.type === 'text'">{{ item.reply_message.message }}</span>

                  <video v-if="item.reply_message.type == 'video'" class="video-container" controls="controls" style="max-height: 100px;">
                    <source :src="item.reply_message.media" type="video/mp4">
                    <!--Suportado em IE9, Chrome 6 e Safari 5 -->
                    O seu navegador não suporta a tag vídeo
                  </video>

                  <audio v-if="item.reply_message.type == 'audio'" controls style="max-height: 80px;">
                    <source :src="item.reply_message.media" type="audio/mpeg">
                    Seu navegador não suporte player de audio.
                  </audio>

                  <div v-if="item.reply_message.type == 'image'" style="border-radius: 6px; overflow: hidden;">
                    <img :src="item.reply_message.media" style="max-width: 100%; max-height: 80px;" />
                  </div>

                  <div v-if="item.reply_message.type == 'document'" class="cursor-pointer pa-2" @click="openFile(item.reply_message.media)">
                    <v-icon size="40">
                      mdi-file-document-outline
                    </v-icon>
                    <div style="font-weight: 400;">
                      Documento
                    </div>
                  </div>
                </div>

                <audio v-if="item.type == 'audio' && item.media_url" controls class="mb-2">
                  <source :src="item.media_url" type="audio/mpeg">
                  Seu navegador não suporte player de audio.
                </audio>
                <span v-if="item.type == 'audio' && item.origin == 'customer'">[TRANSCRIÇÃO]: </span>

                <video v-if="item.type == 'video'" class="video-container" controls="controls">
                  <source :src="item.media_url" type="video/mp4">
                  <!--Suportado em IE9, Chrome 6 e Safari 5 -->
                  O seu navegador não suporta a tag vídeo
                </video>

                <div v-if="item.type == 'image' || (['text', 'location'].includes(item.type) && item.media_url)">
                  <v-img class="cursor-pointer" :src="item.media_url" contain height="auto" max-width="80vw" @click="showImage(item.media_url)" />
                </div>

                <div v-if="item.type == 'document'" class="cursor-pointer pa-2" @click="openFile(item.media_url)">
                  <v-icon size="40">
                    mdi-file-document-outline
                  </v-icon>
                  <div style="font-weight: 400;" class="mt-2">
                    {{ item.file_name || 'Documento' }}
                  </div>
                </div>

                <div v-if="item.canonical_url && item.type != 'location'">
                  <b>{{ item.canonical_url }}</b>
                </div>

                <div v-if="item.type === 'summary'">
                  <b>RESUMO DA CONVERSA</b> <small>(visível apenas na plataforma)</small>
                </div>

                <div v-if="item.type === 'system'">
                  <b>MENSAGEM DE SISTEMA</b> <small>(visível apenas na plataforma)</small>
                </div>

                <div v-html="$utils.renderBoldText(item.message)"></div>

                <div v-if="item.type == 'location' && item.canonical_url" class="d-flex">
                  <v-spacer></v-spacer>
                  <v-btn outlined small class="my-1" @click="openUrl(item.canonical_url)"><v-icon size="14">mdi-google-maps</v-icon> Abrir no maps</v-btn>
                </div>

                <div class="d-flex align-center">
                  <v-btn v-if="selectedConversation.is_manual && selectedChatItem.platform_message_id == item.platform_message_id && !item.deleted && item.type != 'summary' && item.type != 'system'" small icon @click="setReplyMessage(item);" title="Responder">
                    <v-icon size="18">
                      mdi-reply
                    </v-icon>
                  </v-btn>
                  <v-btn v-if="item.origin != 'customer' && selectedChatItem.platform_message_id == item.platform_message_id && !item.deleted && item.type != 'summary'" small icon @click="deleteMessageDialog = true">
                    <v-icon size="18">
                      mdi-trash-can
                    </v-icon>
                  </v-btn>
                  <v-spacer />
                  <div v-if="item.created" class="message-time">
                    {{ $date.smallFormat(item.created) }}
                    <v-icon v-if="item.origin != 'customer'" size="13" :color="item.status >= 4 || last_read_message_index >= message_index ? 'blue' : 'grey'">
                      mdi-check-all
                    </v-icon>
                  </div>
                </div>
              </div>
              <span class="internal-signature" v-if="item.user">Enviado por {{ users[item.user] || 'Colaborador' }}</span>
            </div>

            <div v-if="rendered_messages.length" class="d-flex justify-center mt-1">
              <v-chip dark small color="purple lighten-2" class="cursor-pointer mr-2" @click="summarizeMessages">
                <v-icon size="14" class="mr-2">
                  mdi-creation-outline
                </v-icon> {{ summary_ai_loading ? (isMobile ? 'Resumindo...' : 'Resumindo num passe de mágica...') : (isMobile ? 'Resumir' : 'Resumir com IA') }}
              </v-chip>
              <v-chip v-if="selectedConversation.is_manual" dark small color="purple lighten-2" class="cursor-pointer mr-2" @click="createAIFollowUp">
                <v-icon size="14" class="mr-2">
                  mdi-magic-staff
                </v-icon> {{ follow_up_ai_loading ? (isMobile ? 'Criando...' : 'Criando follow-up personalizado...') : (isMobile ? 'Follow-up' : 'Sugerir follow-up com IA') }}
              </v-chip>
              <v-chip v-if="selectedConversation.is_manual" dark small color="purple lighten-2" class="cursor-pointer" @click="createAIReply">
                <v-icon size="14" class="mr-2">
                  mdi-message-reply-text-outline
                </v-icon> {{ reply_ai_loading ? (isMobile ? 'Sugerindo...' : 'Sugerindo resposta...') : (isMobile ? 'Responder com IA' : 'Sugerir resposta com IA') }}
              </v-chip>
            </div>

            <div v-if="newMessagesCount" class="new-messages-btn">
              <ib-btn small rounded color="primary" @click="scrollMessagesToBottom('smooth')">
                <v-icon left small>mdi-arrow-down</v-icon>
                {{ newMessagesCount }} {{ newMessagesCount == 1 ? 'nova mensagem' : 'novas mensagens' }}
              </ib-btn>
            </div>
          </div>

          <div v-if="selectedConversation.is_manual && !selectedConversation.finished" class="flex-grow-0 command-bar ">
            <!-- Preview da mensagem sendo respondida -->
            <transition name="slide-up">
              <div v-if="replyingMessage" class="reply-preview">
                <div class="reply-preview-content">
                  <v-icon small color="primary" class="mr-1">mdi-reply</v-icon>
                  <div class="reply-preview-info">
                    <span class="reply-preview-origin">{{ replyingMessage.origin === 'customer' ? (selectedConversation?.contact?.override_name || selectedConversation?.contact?.name || 'Cliente') : 'Você' }}</span>
                    <span v-if="replyingMessage.type === 'text' || replyingMessage.type === 'audio'" class="reply-preview-message">{{ replyingMessage.message ? (replyingMessage.message.length > 100 ? replyingMessage.message.substring(0, 100) + '...' : replyingMessage.message) : '' }}</span>
                    <span v-else-if="replyingMessage.type === 'image'" class="reply-preview-message"><v-icon x-small>mdi-image</v-icon> Imagem</span>
                    <span v-else-if="replyingMessage.type === 'video'" class="reply-preview-message"><v-icon x-small>mdi-video</v-icon> Vídeo</span>
                    <span v-else-if="replyingMessage.type === 'document'" class="reply-preview-message"><v-icon x-small>mdi-file-document-outline</v-icon> {{ replyingMessage.file_name || 'Documento' }}</span>
                    <span v-else-if="replyingMessage.type === 'location'" class="reply-preview-message"><v-icon x-small>mdi-map-marker</v-icon> Localização</span>
                  </div>
                </div>
                <v-btn icon x-small @click="replyingMessage = null">
                  <v-icon size="18">mdi-close</v-icon>
                </v-btn>
              </div>
            </transition>

            <div class="d-flex my-3 mr-4 fade flex-grow-1 align-center">
              <v-btn v-show="text == '' && clipboardImage === null" icon class="mr-1" @click="openMedias">
                <v-icon>mdi-paperclip</v-icon>
              </v-btn>

              <v-btn v-show="text == '' && clipboardImage === null" icon class="mr-1" @click="openRecording">
                <v-icon>mdi-microphone</v-icon>
              </v-btn>

              <v-btn icon class="mr-1" @click.stop="toogleDialogEmoji">
                <v-icon>mdi-emoticon-happy-outline</v-icon>
              </v-btn>

              <div id="exampleInputEmoji" @click.stop="() => { }">
                <VEmojiPicker v-show="emojiDialog" :style="{ width: '400px', height: '200' }" :show-search="false" lang="pt-BR" @select="onSelectEmoji" @click.stop="true" />
              </div>

              <ClipboardImageMenu :clipboardImage="clipboardImage" :isSendingClipboardImage="isSendingClipboardImage" @clear-clipboard-image="clearClipboardImage" />

              <v-layout column>
                <v-menu ref="menu" v-model="menuQuick" attach=".ref1" top z-index="999">
                  <v-list dense style="min-height: 200px; max-height: 200px;width: 90vw;max-width: 800px; overflow-y: auto;">
                    <v-list-item v-for="(item, index) in filteredItems" :key="index" background-color="white" @click="text = item.message">
                      <v-list-item-title>{{ item.shortcut }}: {{ item.message.length < 60 ? item.message : item.message.substring(0, 59) + '...' }}</v-list-item-title>
                    </v-list-item>
                  </v-list>
                </v-menu>

                <v-textarea v-model="text" class="ref1 nd-text-field refMenuClipboardImage" outlined background-color="gray25" rows="2" auto-grow no-resize hide-details @keydown.enter="handleKeyDown" @input="handleInput" @paste="handlePaste" />
              </v-layout>

              <v-btn class="ml-2" fab dark small color="success" @click.native="sendMessage">
                <v-icon dark>
                  mdi-send
                </v-icon>
              </v-btn>
            </div>
          </div>
        </div>
      </dialog-or-column>
    </v-row>

    <v-bottom-sheet v-model="filter_sheet">
      <v-list nav dense style="max-height: 65vh; overflow-y: auto;">
        <v-row dense class="px-2">
          <v-col cols="12">
            <v-list-item class="mb-0">
              <v-list-item-title>Situação do atendimento</v-list-item-title>
            </v-list-item>
            <v-list-item class="mb-0">
              <v-btn-toggle v-model="pre_filter.situation" mandatory dense color="primary">
                <v-btn v-for="(item, index) in conversation_situations" :key="index" small :value="item">
                  <v-icon size="18" class="mr-2">
                    {{ item.icon }}
                  </v-icon>
                  <span>{{ item.name }}</span>
                </v-btn>
              </v-btn-toggle>
            </v-list-item>
          </v-col>

          <v-col cols="12">
            <v-list-item class="mb-0">
              <v-list-item-title>Tipo de atendimento</v-list-item-title>
            </v-list-item>
            <v-list-item class="mb-0">
              <v-btn-toggle v-model="pre_filter.types" multiple mandatory dense color="primary">
                <v-btn v-for="(item, index) in types" :key="index" small :value="item">
                  <v-icon size="18" class="mr-2">
                    {{ item.icon }}
                  </v-icon>
                  <span>{{ item.name }}</span>
                </v-btn>
              </v-btn-toggle>
            </v-list-item>
          </v-col>

          <v-col cols="12" sm="6">
            <v-list-item class="mb-0">
              <v-list-item-title>Departamento</v-list-item-title>
            </v-list-item>
            <v-list-item class="mb-0">
              <ib-autocomplete outlined v-model="pre_filter.departments" :items="user_role_departments" :label="pre_filter.departments?.length ? 'Departamentos selecionados' : 'Todos os departamentos'" prepend-inner-icon="mdi-briefcase-outline" item-text="name" item-value="_id" small-chips return-object clearable multiple hide-details></ib-autocomplete>
            </v-list-item>
          </v-col>

          <v-col cols="12" sm="6">
            <v-list-item class="mb-0">
              <v-list-item-title>Tags</v-list-item-title>
            </v-list-item>
            <v-list-item class="mb-0">
              <ib-autocomplete outlined v-model="pre_filter.tags" :items="tags" :label="pre_filter.tags?.length ? 'Tags selecionadas' : 'Todas as tags'" prepend-inner-icon="mdi-tag-multiple-outline" item-text="name" item-value="_id" small-chips return-object clearable multiple hide-details></ib-autocomplete>
            </v-list-item>
          </v-col>

          <v-col cols="12" sm="6">
            <v-list-item class="mb-0">
              <v-list-item-title>Chips</v-list-item-title>
            </v-list-item>
            <v-list-item class="mb-0">
              <ib-autocomplete outlined v-model="pre_filter.chips" :items="allowed_all_chips" :label="pre_filter.chips?.length ? 'Chips selecionados' : 'Todos os chips'" prepend-inner-icon="mdi-whatsapp" item-text="name" item-value="_id" small-chips return-object clearable multiple hide-details></ib-autocomplete>
            </v-list-item>
          </v-col>

          <v-col cols="12" sm="6">
            <v-list-item class="mb-0">
              <v-list-item-title>Período</v-list-item-title>
            </v-list-item>
            <v-list-item class="mb-0">
              <v-menu ref="menuDate" v-model="menuDate" :close-on-content-click="false" :return-value.sync="pre_filter.date" transition="scale-transition" offset-y min-width="auto">
                <template #activator="{ on, attrs }">
                  <ib-text-field v-model="dateLabel" prepend-inner-icon="mdi-calendar-range" label="Selecione o período" clearable hide-details readonly v-bind="attrs" v-on="on" @click:clear="clearDate" />
                </template>
                <v-date-picker v-model="pre_filter.date" locale="pt-BR" color="primary" range no-title scrollable>
                  <v-spacer />
                  <ib-btn color="gray200" outlined @click="clearDate">
                    <div class="gray1000--text">
                      Limpar
                    </div>
                  </ib-btn>
                  <ib-btn color="primary" @click="applyDateFilter">
                    Aplicar
                  </ib-btn>
                </v-date-picker>
              </v-menu>
            </v-list-item>
          </v-col>

          <v-col cols="12">
            <v-list-item class="mb-0">
              <v-list-item-title>Busca individual</v-list-item-title>
            </v-list-item>
            <v-list-item class="mb-2">
              <ib-text-field prepend-inner-icon="mdi-account-outline" v-model="pre_filter.text" outlined label="Nome ou telefone" hide-details="auto" />
            </v-list-item>
          </v-col>
        </v-row>

        <v-list-item>
          <div class="filter-item my-3" style="display: flex; width: 100%;">
            <v-spacer />
            <ib-btn dark outlined color="error" class="mr-4" @click="clearFilters">
              Limpar filtros
            </ib-btn>
            <ib-btn dark color="primary" @click="applyFilters">
              Aplicar filtros
            </ib-btn>
          </div>
        </v-list-item>
      </v-list>
    </v-bottom-sheet>

    <ib-dialog v-model="deleteMessageDialog" overlay-opacity="0.5" overlay-color="black" max-width="350">
      <v-card>
        <ib-dialog-header title="Apagar mensagem" :close="() => { deleteMessageDialog = false }"></ib-dialog-header>
        <v-card-text> Tem certeza que deseja apagar essa mensagem? Essa ação é irreversível.</v-card-text>
        <v-card-actions>
          <ib-btn outlined color="gray200" @click="deleteMessageDialog = false;">
            <div class="gray1000--text">
              Cancelar
            </div>
          </ib-btn>

          <v-spacer />

          <ib-btn color="error" @click="deleteMessageDialog = false; deleteMessage()">
            Apagar
          </ib-btn>
        </v-card-actions>
      </v-card>
    </ib-dialog>

    <ib-dialog v-model="deleteAutoFollowUpDialog" overlay-opacity="0.5" overlay-color="black" max-width="350">
      <v-card>
        <ib-dialog-header title="Desativar follow-up" :close="() => { deleteAutoFollowUpDialog = false }"></ib-dialog-header>
        <v-card-text> Tem certeza que deseja desativar o follow-up automático desta conversa? Ele só poderá ser habilitado novamente se uma nova conversa com este contato for iniciada.</v-card-text>
        <v-card-actions>
          <ib-btn outlined color="gray200" @click="deleteAutoFollowUpDialog = false;">
            <div class="gray1000--text">
              Cancelar
            </div>
          </ib-btn>

          <v-spacer />

          <ib-btn color="error" @click="deleteAutoFollowUpDialog = false; selectedConversation.auto_follow_up = null; changeConversationData()">
            Desativar
          </ib-btn>
        </v-card-actions>
      </v-card>
    </ib-dialog>


    <ib-dialog v-model="newConversationDialog" overlay-opacity="0.5" overlay-color="black" max-width="650" content-class="ib-scroll">
      <v-card>
        <ib-dialog-header title="Nova conversa" subtitle="Inicie uma nova conversa por aqui" :close="() => { newConversationDialog = false }"></ib-dialog-header>

        <v-card-text>
          <v-row>
            <v-col cols="12" sm="6">
              <ib-select v-model="new_conversation_chip" @change="changeTemplates" outlined :items="allowed_chips" item-text="name" return-object no-data-text="Não há números conectados" item-value="_id" label="Canal de comunicação" hide-details="auto" />
            </v-col>

            <v-col cols="12" sm="6">
              <ib-select v-model="new_conversation_department" outlined :items="user_role_departments" item-text="name" no-data-text="Não há departamentos" item-value="_id" label="Departamento" hide-details="auto" />
            </v-col>

            <v-col cols="12" v-if="new_conversation_chip.official">
              <template-composer v-model="new_conversation_template" :templates="templates" :medias="medias" :update-medias="updateMedias" />
            </v-col>

          </v-row>
        </v-card-text>

        <v-card-text>
          <v-radio-group v-model="new_conversation_contact_type" class="my-2" row hide-details="auto">
            <v-radio label="Contato existente" value="existing" />
            <v-radio label="Novo contato" value="new" />
          </v-radio-group>
        </v-card-text>

        <v-card-text v-if="new_conversation_contact_type == 'existing'">
          <ib-autocomplete v-model="new_contact" return-object outlined :items="contacts" :loading="loading" chips small-chips clearable hide-details="auto" :item-text="getItemText" :filter="() => true" item-value="_id" label="Selecione um contato" :menu-props="{ top: true, offsetY: true }" @update:search-input="searchContacts">
            <template #no-data>
              <v-list-item>
                <v-list-item-title>
                  Busque um contato pelo
                  <strong>nome ou telefone</strong>
                </v-list-item-title>
              </v-list-item>
            </template>
            <template #selection="{ attr, on, item, selected }">
              <v-chip v-bind="attr" :input-value="selected" color="primary" class="white--text" small v-on="on">
                <span v-text="item.override_name || item.name" />
              </v-chip>
            </template>
            <template #item="{ item }">
              <v-list-item-avatar class="text-h5 font-weight-light white--text">
                <ib-user-avatar :user="item" size="40" />
              </v-list-item-avatar>
              <v-list-item-content>
                <v-list-item-title v-text="item.override_name || item.name" />
                <v-list-item-subtitle v-text="item.phone" />
              </v-list-item-content>
            </template>
          </ib-autocomplete>
        </v-card-text>

        <v-card-text v-if="new_conversation_contact_type == 'new'">
          <v-row>
            <v-col cols="3">
              <ib-text-field v-model="country_code" outlined label="Cód País" hide-details="auto" />
            </v-col>
            <v-col cols="9">
              <ib-text-field v-model="new_conversation_phone" outlined label="Telefone com DDD" hide-details="auto" @change="new_conversation_jid = false" />
            </v-col>
          </v-row>
        </v-card-text>

        <v-card-actions>
          <ib-btn outlined color="gray200" @click="newConversationDialog = false;">
            <div class="gray1000--text">
              Cancelar
            </div>
          </ib-btn>

          <v-spacer />

          <ib-btn color="primary" :loading="loading" @click="startNewConversation">
            Iniciar conversa
          </ib-btn>
        </v-card-actions>
      </v-card>
    </ib-dialog>

    <ib-dialog v-model="tagsDialog" overlay-opacity="0.5" overlay-color="black" persistent max-width="600">
      <v-card>
        <ib-dialog-header title="Atribuir tags" :subtitle="`Organize o atendimento de  ${selectedConversation?.contact?.override_name || selectedConversation?.contact?.name}`" :close="() => { tagsDialog = false }"></ib-dialog-header>

        <v-card-text v-if="selectedConversation?.contact">
          <ib-autocomplete v-model="selectedConversation.contact.tags" chips small-chips multiple outlined :items="tags" item-text="name" item-value="_id" label="Tags ou rótulos" hide-details="auto">
            <template #selection="{ item }">
              <ib-chip small :color="item.color">
                {{ item.name }}
              </ib-chip>
            </template>
          </ib-autocomplete>
        </v-card-text>

        <v-card-actions>
          <ib-btn outlined color="gray200" @click="tagsDialog = false;">
            <div class="gray1000--text">
              Cancelar
            </div>
          </ib-btn>

          <v-spacer />

          <ib-btn color="primary" @click="tagsDialog = false; changeContactTags()">
            Salvar
          </ib-btn>
        </v-card-actions>
      </v-card>
    </ib-dialog>

    <ib-dialog v-model="transferDialog" overlay-opacity="0.5" overlay-color="black" persistent max-width="600">
      <v-card>
        <ib-dialog-header title="Transferir atendimento" :subtitle="`Organize o atendimento de ${selectedConversation?.contact?.override_name || selectedConversation?.contact?.name}`" :close="() => { transferDialog = false }"></ib-dialog-header>

        <v-card-text class="container-transfer" v-if="selectedConversation?.contact">
          <ib-select v-model="transferType" chips mandatory small-chips :items="[{ text: 'Transferir para chatbot', value: 'chatbot' }, { text: 'Transferir para fluxo', value: 'flow' }, { text: 'Transferir para departamento', value: 'department' }]" label="Transferência" color="primary" outlined hide-details="auto" />

          <ib-autocomplete v-show="transferType === 'chatbot'" v-model="selectedConversation.chatbot" chips small-chips outlined :items="chatbots" item-text="name" item-value="_id" label="Chatbot" return-object hide-details="auto">
            <template #selection="{ item }">
              <ib-chip :tonal="!$isDark" small color="primary">
                {{ item.name }}
              </ib-chip>
            </template>
          </ib-autocomplete>

          <ib-autocomplete v-show="transferType === 'flow'" v-model="transfer_flow" chips small-chips outlined :items="flows" item-text="name" item-value="_id" label="Fluxo" return-object hide-details="auto">
            <template #selection="{ item }">
              <ib-chip :tonal="!$isDark" small color="primary">
                {{ item.name }}
              </ib-chip>
            </template>
          </ib-autocomplete>

          <ib-autocomplete v-show="transferType === 'department'" v-model="transfer_department" chips small-chips outlined :items="departments" item-text="name" item-value="_id" label="Departamento" return-object hide-details="auto">
            <template #selection="{ item }">
              <ib-chip :tonal="!$isDark" small color="primary">
                {{ item.name }}
              </ib-chip>
            </template>
          </ib-autocomplete>
        </v-card-text>

        <v-card-actions>
          <ib-btn outlined color="gray200" @click="transferDialog = false">
            <div class="gray1000--text">
              Cancelar
            </div>
          </ib-btn>

          <v-spacer />

          <ib-btn color="primary" :disabled="!transferType" @click="transferConversation()">
            Transferir
          </ib-btn>
        </v-card-actions>
      </v-card>
    </ib-dialog>

    <DialogCreateOpportunity v-model="createOpportunityDialog" :opportunity="newOpportunity" :funnels="funnels" :steps="opportunitySteps" :users-list="users_list" :saving="savingOpportunity" :step-value="newOpportunity ? newOpportunity.step : null" @funnel-change="loadFunnelSteps" @save="createOpportunityFromConversation" @update-field="updateOpportunityField" @step-change="updateOpportunityStep" />

    <v-overlay v-model="imageViewerDialog" z-index="99999" opacity="0.9">
      <v-img :src="media_url" contain style="max-height: 85vh;max-width:85vw" />
      <div style="text-align: center;">
        <ib-btn outlined class="mt-2 mr-4" large color="error lighten-1" @click="imageViewerDialog = false">
          <v-icon class="mr-2">
            mdi-close
          </v-icon>
          Fechar
        </ib-btn>
        <ib-btn class="mt-2" large color="primary" @click="$saveImage(media_url)">
          <v-icon class="mr-2">
            mdi-content-save-outline
          </v-icon>
          Salvar
        </ib-btn>
      </div>
    </v-overlay>

    <dialog-medias v-model="dialogMedia" :medias="medias" :update-medias="updateMedias" :send-media="sendMedia" />
    <dialog-scheduled-message v-model="dialogScheduledMessage" :phone="selectedConversation?.contact?.phone" :currentChip="selectedConversation?.chip?._id" :chips="chips" :templates="templates" :flows="flows" />
    <dialog-recording v-model="dialogRecording" :send-media="sendMedia" />
    <contact-drawer v-model="contactDrawer" :contact_id="selectedContact" :tags_dictionary="tags_dictionary" />

    <DialogEditContactName v-model="dialogEditContactName" :contact="selectedConversation?.contact" />

    <dialog-finish-conversations v-if="['owner', 'manager'].includes(currentUser?.user_role)" v-model="dialogFinishConversations" :active-filters="options.filter" :pre-filters="pre_filter" :tags="tags" :departments="departments" :chips="allowed_all_chips" />

    <dialog-transfer-conversations-department v-if="['owner', 'manager'].includes(currentUser?.user_role)" v-model="dialogTransferDepartmentConversations" :active-filters="options.filter" :pre-filters="pre_filter" :tags="tags" :departments="departments" :chips="allowed_all_chips" />

    <dialog-add-tag-conversations v-if="['owner', 'manager'].includes(currentUser?.user_role)" v-model="dialogAddTagConversations" :active-filters="options.filter" :pre-filters="pre_filter" :tags="tags" :departments="departments" :chips="allowed_all_chips" />

    <ib-dialog v-model="sendTemplateDialog" overlay-opacity="0.5" overlay-color="black" max-width="650" content-class="ib-scroll">
      <v-card>
        <ib-dialog-header title="Enviar template" subtitle="Envie um template aprovado para este contato" :close="() => { sendTemplateDialog = false }"></ib-dialog-header>

        <v-card-text>
          <template-composer v-model="selectedTemplate" :templates="templates" :medias="medias" :update-medias="updateMedias" />
        </v-card-text>

        <v-card-actions>
          <ib-btn outlined color="gray200" @click="sendTemplateDialog = false;">
            <div class="gray1000--text">
              Cancelar
            </div>
          </ib-btn>

          <v-spacer />

          <ib-btn color="primary" :loading="sendTemplateLoading" :disabled="!selectedTemplate?.valid" @click="sendTemplateToContact">
            Enviar template
          </ib-btn>
        </v-card-actions>
      </v-card>
    </ib-dialog>
  </div>
</template>

<script>
let socket;
let socket_connection_count = 0;

let official_socket;
let official_socket_connection_count = 0;

import Api from "@/lib/Api";
import MessagePreview from "@/components/MessagePreview";
import DialogOrColumn from "@/components/DialogOrColumn";
import DialogMedias from "@/components/DialogMedias";
import DialogFinishConversations from "@/components/DialogFinishConversations.vue";
import DialogTransferConversationsDepartment from "@/components/DialogTransferConversationsDepartment.vue";
import DialogAddTagConversations from "@/components/DialogAddTagConversations.vue";
import DialogRecording from "@/components/DialogRecording";
import DialogScheduledMessage from "@/components/DialogScheduledMessage";
import ContactDrawer from "@/components/ContactDrawer";
import DialogEditContactName from "@/components/DialogEditContactName.vue";
import ClipboardImageMenu from "@/components/ClipboardImageMenu.vue";
import ContextWindowTimer from "@/components/ContextWindowTimer.vue";
import DialogCreateOpportunity from "@/components/DialogCreateOpportunity.vue";
import TemplateComposer from "@/components/TemplateComposer.vue";
import { emitToastr, formatMaskedCurrencyToNumber, normalizePhone } from "@/lib/Utils";
import { VEmojiPicker } from 'v-emoji-picker';
let timeout = null;

export default {
  name: "AtendimentoView",

  components: {
    MessagePreview,
    DialogOrColumn,
    DialogMedias,
    DialogFinishConversations,
    DialogTransferConversationsDepartment,
    DialogAddTagConversations,
    DialogRecording,
    DialogScheduledMessage,
    ContactDrawer,
    VEmojiPicker,
    DialogEditContactName,
    ClipboardImageMenu,
    ContextWindowTimer,
    DialogCreateOpportunity,
    TemplateComposer
  },

  data() {
    return {
      selectedChatItem: {},
      filter_sheet: false,
      objects: [],
      tagsDialog: false,
      transferDialog: false,
      dialogMedia: false,
      dialogRecording: false,
      dialogScheduledMessage: false,
      newConversationDialog: false,
      deleteMessageDialog: false,
      dialogFinishConversations: false,
      dialogTransferDepartmentConversations: false,
      dialogAddTagConversations: false,
      contactDrawer: false,
      selectedContact: null,
      emojiDialog: false,
      imageViewerDialog: null,
      deleteAutoFollowUpDialog: null,
      transfer_department: null,
      transfer_flow: null,
      createOpportunityDialog: false,
      newOpportunity: null,
      savingOpportunity: false,
      funnels: [],
      opportunitySteps: [],
      users_list: [],
      money: { decimal: ',', thousands: '.', prefix: 'R$ ', precision: 2, masked: false },

      menuDate: false,
      menuQuick: false,
      filteredItems: [],

      media_url: '',
      selectedConversation: {},
      showConversation: false,
      pre_filter: {
        text: '', changed: false, tags: [], departments: [], chips: [],
        types: [
          { name: 'Chatbot', id: 'chatbot', icon: 'mdi-robot-outline' },
          { name: 'Humano', id: 'human', icon: 'mdi-face-agent' }
        ],
        situation: 'all',
        date: []
      },
      can_clear: false,
      totalObjects: 0,
      options: { filter: { text: '', finished: undefined }, limit: 15 },
      messages: [],
      rendered_messages: [],
      last_read_message_index: -1,
      quick_messages: [],
      autoselectMenu: false,
      button_load_more: true,
      text: "",
      loading: true,
      typing: false,
      types: [
        { name: 'Chatbot', id: 'chatbot', icon: 'mdi-robot-outline' },
        { name: 'Humano', id: 'human', icon: 'mdi-face-agent' }
      ],
      conversation_situations: [
        { name: 'Todas', id: 'all', icon: 'mdi-forum-outline' },
        { name: 'Não respondidas', id: 'waiting_response', icon: 'mdi-message-text-clock-outline' }
      ],
      chips: [],
      allowed_chips: [],
      allowed_all_chips: [],
      medias: [],
      users: {},
      departments: [],
      templates: [],
      user_role_departments: [],
      flows: [],
      chatbots: [],
      transferType: 'chatbot',
      contacts: [],
      tags: [],
      tags_dictionary: {},
      new_conversation_phone: "",
      new_conversation_contact_type: "existing",
      country_code: "55",
      new_conversation_jid: false,
      new_conversation_chip: false,
      new_conversation_department: false,
      new_conversation_template: null,
      new_contact: null,
      summary_ai_loading: false,
      follow_up_ai_loading: false,
      reply_ai_loading: false,
      auto_follow_up: null,
      dialogEditContactName: false,
      clipboardImage: null,
      fileClipboardImage: null,
      isSendingClipboardImage: false,
      sendTemplateDialog: false,
      sendTemplateLoading: false,
      selectedTemplate: null,
      replyingMessage: null,
      resizeObserver: null,
      wasScrollAtBottom: false,
      newMessagesCount: 0,
    };
  },

  computed: {
    objectsWithLoadMore() {
      return [...this.objects, { isLoadMoreButton: true }];
    },
    currentUser() {
      return this.$store.state.currentUser;
    },

    isMobile() {
      return this.$vuetify.breakpoint.smAndDown;
    },

    isContextWindowExpired() {
      if (!this.selectedConversation?.context_window) return true;
      const remaining = this.$date.calcContextWindow(this.selectedConversation.context_window);
      return !remaining || !remaining.text;
    },

    showMessageDialog() {
      if (this.conversation?._id) return true;
      return false;
    },
    getSelectedTypes() {
      if (this.pre_filter?.types && this.pre_filter.types.length > 0) {
        let selections = '';
        this.pre_filter.types.forEach(i => selections = selections + `, ${i.name}`)
        return selections.substring(2);
      }
      else {
        return 'Todos os tipos'
      }
    },

    getSelectedDepartments() {
      if (this.pre_filter?.departments && this.pre_filter.departments.length > 0) {
        let selections = '';
        this.pre_filter.departments.forEach(i => selections = selections + `, ${i.name}`)
        return selections.substring(2);
      }
      else {
        return 'Todos os departamentos'
      }
    },

    getSelectedTags() {
      if (this.pre_filter?.tags && this.pre_filter.tags.length > 0) {
        let selections = '';
        this.pre_filter.tags.forEach(i => selections = selections + `, ${i.name}`)
        return selections.substring(2);
      }
      else {
        return 'Todos os contatos'
      }
    },

    getSelectedChips() {
      if (this.pre_filter?.chips && this.pre_filter.chips.length > 0) {
        let selections = '';
        this.pre_filter.chips.forEach(i => selections = selections + `, ${i.name}`)
        return selections.substring(2);
      }
      else {
        return 'Todos os chips'
      }
    },

    getSelectedDateRange() {
      const formatDate = (dateStr) => {
        if (!dateStr) return null;
        const date = new Date(dateStr + 'T00:00:00');
        return date.toLocaleDateString('pt-BR');
      };

      if (this.pre_filter.date && this.pre_filter.date.length === 2) {
        return `${formatDate(this.pre_filter.date[0])} até ${formatDate(this.pre_filter.date[1])}`;
      } else if (this.pre_filter.date && this.pre_filter.date.length === 1) {
        return `${formatDate(this.pre_filter.date[0])}`;
      }
      return 'Todas as datas';
    },

    dateLabel() {
      const fmt = s => s && s.length === 10 ? `${s.slice(8, 10)}/${s.slice(5, 7)}/${s.slice(0, 4)}` : '';

      if (this.pre_filter.date && this.pre_filter.date.length) {
        return [fmt(this.pre_filter.date[0]), fmt(this.pre_filter.date[1])].filter(Boolean).join(' — ');
      }
      return '';
    }
  },
  watch: {
    text(value) {
      if (value.endsWith('/')) {
        this.filteredItems = this.quick_messages;
        this.menuQuick = true;
      } else if (!value.includes('/')) {
        this.menuQuick = false;
      }
    },
    new_conversation_chip(newVal) {
      if (newVal) this.changeTemplates();
    }
  },

  async mounted() {
    this.loading = true;

    const chips = await Api.getChipNumbersByUser();

    if (!chips.error && chips.message) {
      this.chips = chips.message.filter(i => i.status == 'open');

      if (this.currentUser.user_role === 'user') {
        this.allowed_chips = this.chips.filter(c => (this.currentUser.departments || []).includes(c.department));
        this.allowed_all_chips = chips.message.filter(c => (this.currentUser.departments || []).includes(c.department));
      }
      else {
        this.allowed_chips = this.chips;
        this.allowed_all_chips = chips.message;
      }

      if (this.allowed_chips.length) this.new_conversation_chip = this.allowed_chips[0];

      //INICIANDO SOCKETS OFICIAL E NÃO OFICIAL
      if (chips.message.filter(i => i.official === true).length > 0 && !official_socket) this.startSocket(official_socket, official_socket_connection_count, true);
      if (chips.message.filter(i => !i.official).length > 0 && !socket) this.startSocket(socket, socket_connection_count, false);
    }
    else {
      emitToastr("error", "Erro ao carregar canais. Por favor atualize a página");
    }

    //CHAMADAS ESSENCIAIS PARA CARREGAR
    const [tags, departments] = await Promise.all([Api.getTagsByUser(), Api.getDepartmentsByUser()]);


    if (!tags.error && tags.message) this.tags = tags.message;
    this.tags.forEach(i => this.tags_dictionary[i._id] = { name: i.name, color: i.color });

    if (!departments.error && departments.message) {
      this.departments = departments.message;

      if (this.currentUser.user_role == 'user') {
        this.user_role_departments = this.departments.filter(d => (this.currentUser.departments || []).includes(d._id.toString()));
      }
      else {
        this.user_role_departments = this.departments;
      }
    }

    this.buildFilter();
    
    // Verifica se há um contato passado como parâmetro da rota (vindo do Kanban)
    if (this.$route.params.contactFilter) {
      const contact = this.$route.params.contactFilter;
      this.pre_filter.text = contact.phone;
      this.can_clear = true;
      this.buildFilter();
      this.$router.replace({ name: 'Atendimento', params: {} });
    }

    // Verifica se há um filtro passado como parâmetro da rota (vindo dos cards do Dashboard)
    if (this.$route.params.conversationFilter) {
      this.applyRouteFilter(this.$route.params.conversationFilter);
      this.$router.replace({ name: 'Atendimento', params: {} });
    }

    //NOTE: OK
    await this.getConversations(this.options);


    if (this.isMobile) {
      try {
        document.removeEventListener("visibilitychange", () => { });
        document.addEventListener("visibilitychange", async () => {
          if (!document.hidden) this.getConversations(this.options);
        });
      }
      catch (err) {
        console.log(err.message)
      }
    }

    //CHAMADAS QUE PODEM SER CARREGADAS APÓS AS CONVERSAS
    const [quick_messages, medias, users, flows, auto_follow_up, chatbots] = await Promise.all([Api.getQuickMessagesByUser(), Api.getMediasByUser(), Api.getTeamUsers(), Api.getFlowsByUser(), Api.getAutoFollowUps(), Api.getChatbotsByUser()]);

    if (!quick_messages.error && quick_messages.message) {
      this.quick_messages = [];
      quick_messages.message.forEach(m => this.quick_messages.push({ shortcut: `/${m.shortcut}`, message: m.message }));
    }

    if (!medias.error && medias.message) {
      this.medias = medias.message;
    }

    if (!users.error && users.message) {
      this.users = {};
      users.message.forEach(u => { this.users[u._id.toString()] = u.name; })
    }

    if (!flows.error && flows.message) {
      this.flows = flows.message;
    }

    if (!auto_follow_up.error && auto_follow_up.message) {
      this.auto_follow_up = auto_follow_up.message;
    }

    if (!chatbots.error && chatbots.message) {
      this.chatbots = chatbots.message;
    }
  },

  async beforeDestroy() {
    if (socket) {
      socket.disconnect();
      socket = null;
    }
    if (official_socket) {
      official_socket.disconnect();
      official_socket = null;
    }
    
    this.cleanupScrollObservers();
  },

  methods: {
    filteredTags(tags) {
      if (!tags) return [];
      return tags.filter(tag => this.tags_dictionary[tag]);
    },

    setReplyMessage(message) {
      this.replyingMessage = message;
      setTimeout(() => {
        this.$nextTick(() => {
          this.scrollMessagesToBottom('smooth');
        });
      }, 200);
    },

    async changeTemplates() {
      this.templates = [];
      this.new_conversation_department = null;
      this.new_conversation_template = null;

      if (this.new_conversation_chip && this.new_conversation_chip.waba) {
        const templates = await Api.getTemplateMessages(this.new_conversation_chip.waba);
        if (!templates.error && templates.message) this.templates = templates.message.filter(t => t.status === 'APPROVED');
      }
    },

    toogleDialogEmoji() {
      this.emojiDialog = !this.emojiDialog;
    },
    onSelectEmoji(emoji) {
      this.text += emoji.data;
      // Optional
      // this.toogleDialogEmoji();
    },
    async handleKeyDown(event) {
      const isMobile = /Android|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);

      if (event.key === 'Enter') {
        if (event.shiftKey || isMobile) return;

        event.preventDefault();
        if (this.fileClipboardImage !== null) {
          await this.sendClipboardImage(this.fileClipboardImage)
          return
        }
        this.sendMessage();
      }
    },

    handleInput() {
      if (this.text && this.text[0] == '/') {
        this.filteredItems = this.quick_messages.filter((item) =>
          item.shortcut.toLowerCase().includes(this.text.split('/').pop().toLowerCase())
        );
        this.menuQuick = true;
      } else {
        this.menuQuick = false;
      }
    },

    buildFilter() {
      this.options.filter.types = this.pre_filter.types;
      this.options.filter.tags = this.pre_filter.tags;
      this.options.filter.text = this.pre_filter.text;
      this.options.filter.situation = this.pre_filter.situation?.id;
      this.options.filter.chips = this.pre_filter.chips;
      this.options.limit = 15;

      // Tratando datas
      if (this.pre_filter.date && this.pre_filter.date.length > 0) {
        const sortedDates = [...this.pre_filter.date].sort();
        
        this.options.filter.start_date = new Date(sortedDates[0] + 'T00:00:00').toISOString();
        
        if (sortedDates.length === 2) {
          this.options.filter.end_date = new Date(sortedDates[1] + 'T23:59:59').toISOString();
        } else {
          this.options.filter.end_date = new Date(sortedDates[0] + 'T23:59:59').toISOString();
        }
      } else {
        delete this.options.filter.start_date;
        delete this.options.filter.end_date;
      }

      //TRATANDO DEPARTAMENTOS
      if (this.currentUser.user_role == 'user') {
        if (!this.currentUser.departments) this.currentUser.departments = [];

        if (this.pre_filter.departments.length == 0) {
          this.pre_filter.departments = this.user_role_departments;
        }
      }

      this.options.filter.departments = this.pre_filter.departments;
    },

    sortConversations() {
      this.objects = this.objects.sort((a, b) => {
        const dateA = a.last_message && a.last_message.created ? new Date(a.last_message.created).getTime() : 0;
        const dateB = b.last_message && b.last_message.created ? new Date(b.last_message.created).getTime() : 0;
        return dateB - dateA;
      });
    },

    async sendMessage(media = {}) {
      if (media.type === 'click') media = {};
      if (!media?._id && !media?.url && this.text.trim() == '' && this.fileClipboardImage === null) return;

      if (this.fileClipboardImage !== null) {
        await this.sendClipboardImage(this.fileClipboardImage)
        return
      }

      this.$nextTick(async () => {
        const m_id = this.$newID('.OP');
        this.selectedConversation.waiting_response = false;

        let textSigned = `*${this.currentUser.name.trim()}*\n${this.text}`

        const reply_message = this.replyingMessage ? {
          type: this.replyingMessage.type,
          message: this.replyingMessage.message,
          media: this.replyingMessage.media_url,
          file_name: this.replyingMessage.file_name,
          origin: this.replyingMessage.origin,
          platform_message_id: this.replyingMessage.platform_message_id
        } : null;

        this.pushMessage({ created: new Date(), event: 'new_message', conversation_id: this.selectedConversation._id, message: this.currentUser.config?.user_signature ? textSigned : this.text.trim(), message_id: m_id, platform_message_id: m_id, origin: 'user', type: media.type || 'text', media_url: media?.url, user: this.currentUser._id, reply_message });

        let send_message_call = Api.sendConversationMessage(this.selectedConversation._id, this.currentUser.config?.user_signature ? textSigned : this.text, m_id, media, reply_message);
        this.selectedConversation.waiting_response = false;
        this.selectedConversation.is_new = false;
        this.text = "";
        this.replyingMessage = null;

        send_message_call = await send_message_call;

        //APAGANDO MENSAGEM COM ERRO
        if (send_message_call.error) {
          const error_message_index = this.rendered_messages.findIndex(m => m.message_id === m_id);
          this.rendered_messages.splice(error_message_index, 1);
        }
      });
    },

    startSocket(localSocket, localCounter, official = false) {
      if (localCounter >= 3) {
        emitToastr("error", "Erro na conexão com o socket. Atualize a página para tentar novamente.");
        return;
      }

      if (!this.$store.state.SOCKET_IO_URL) {
        localCounter++
        setTimeout(() => { this.startSocket(); }, 500 + localCounter * 2000);
        emitToastr("info", "Aguardando endereço do socket...");
        return;
      }

      localCounter = 0;
      localSocket = this.$io(official ? this.$store.state.OFFICIAL_SOCKET_IO_URL : this.$store.state.SOCKET_IO_URL, { path: '/sock/' });

      localSocket.on("connect", async () => {
        localSocket.emit("join-room", `account_conversations_${this.currentUser?.account?._id}`);
      });

      localSocket.on("receive-message", data => {
        if (data.event === "new_message") {
          // Ignorar mensagens de sync enviadas pelo próprio usuário (evita duplicação)
          if (data.is_sync && data.user && data.user.toString() === this.currentUser._id.toString()) return;
          
          this.pushMessage(data);
        }

        if (data.event === "new_conversation") {
          setTimeout(() => {
            this.getConversations({ ...this.options, conversation_id: data.conversation._id }, true);
          }, 2000);
        }

        if (data.event === "conversation_updated") {
          setTimeout(() => {
            this.getConversations({ ...this.options, conversation_id: data.conversation._id }, true);
          }, 1000);
        }

        if (data.event === "conversation_finished") {
          if (this.selectedConversation?._id?.toString() == data.conversation_id) {
            if (data.user_id && this.currentUser._id != data.user_id) emitToastr("info", "Essa conversa foi finalizada por outro usuário");
            this.selectedConversation = {};
            this.messages = [];
            this.rendered_messages = [];
          }

          const c_index = this.objects.findIndex(i => i._id.toString() == data.conversation_id);
          if (c_index != -1) {
            this.objects.splice(c_index, 1);
            this.$forceUpdate();
          }
        }

        if (data.event === "message_read") {
          if (this.showConversation && this.selectedConversation?._id?.toString() == data.conversation_id) this.setMessagesRead(data.platform_message_id);
        }

        if (data.event === "set_manual") {
          this.getConversations({ ...this.options, conversation_id: data.conversation_id }, true);

          if (this.selectedConversation?._id?.toString() == data.conversation_id.toString()) {
            this.selectedConversation.is_manual = true;
          }
        }
      });
    },

    findConversationIndex(conversation_id) {
      return this.objects.findIndex(c => c._id.toString() === conversation_id);
    },

    async getConversations(options, notify = false) {
      this.loading = true;
      let resp = await Api.getConversationsWithLastMessage(options);
      this.loading = false;

      const last_conversation_list_length = this.objects.length;

      if (!resp.error) {
        //ÚNICA CONVERSA
        if (options.conversation_id) {
          const conversation_index = this.findConversationIndex(options.conversation_id);

          if (conversation_index != -1) {
            //EXISTE NA LISTA
            if (resp.message) {
              //O USUÁRIO PODE VER A CONVERSA - SUBSTITUIR
              this.objects[conversation_index] = resp.message;
            }
            else {
              //NÃO PODE VER A CONVERSA - APAGAR
              this.objects.splice(conversation_index, 1);
            }
          }
          else {
            //NÃO EXISTE NA LISTA
            if (resp.message) {
              this.objects.push(resp.message);
            }
          }
        }
        else {
          //LISTA DE CONVERSAS
          this.objects = resp.message;
          this.button_load_more = resp.load_more;
        }

        if (this.pre_filter.tags.length > 0) this.objects = this.objects.filter(i => this.pre_filter.tags.some(j => i.contact?.tags.includes(j._id)));
        this.totalObjects = resp.total_count || resp.message.length;

        if (this.selectedConversation?._id) {
          this.selectedConversation = this.objects.find(x => x._id == this.selectedConversation._id);
        }

        if (!this.selectedConversation) {
          this.selectedConversation = {};
          this.messages = [];
          this.rendered_messages = [];
        }

        this.sortConversations();

        //NOTIFICAR CASO TENHA UMA MENSAGEM NOVA
        if (notify && last_conversation_list_length < this.totalObjects) this.$notify("InteligênciaBot", "Nova conversa");
      }
    },

    async pushMessage(data) {
      const conversation_index = this.findConversationIndex(data.conversation_id);

      if (conversation_index != -1) {
        //CONVERSA EXISTE NA LISTA
        if (data.type && data.type != 'summary') this.objects[conversation_index].last_message = data;

        if (data.origin === 'customer') {
          this.objects[conversation_index].waiting_response = true;

          if (data.context_window) this.$set(this.objects[conversation_index], 'context_window', data.context_window);
        }
        else {
          this.objects[conversation_index].waiting_response = false;
          //if (this.options.filter.situation == "waiting_response") this.objects.splice(conversation_index, 1);
        }

        this.sortConversations();
        this.$forceUpdate()
      }
      else {
        //CONVERSA NÃO ESTÁ LISTADA
        setTimeout(() => {
          this.getConversations({ ...this.options, conversation_id: data.conversation_id }, true);
        }, 1000);
      }

      if (data?.conversation_id.toString() != this.selectedConversation?._id?.toString()) {
        const canHearNotification = this.currentUser.user_role !== 'user' || conversation_index !== -1;
        if (this.selectedConversation?._id?.toString() != data.conversation_id.toString() && data.origin == 'customer' && !this.currentUser.config?.disable_notification_sound && canHearNotification) this.$playNotificationSound();
        return;
      }

      let delay = 1;

      if (data.origin == 'customer') {
        this.typing = true;
        delay = 1000;
      }

      let message = this.messages.find(m => m.message_id == data.message_id);
      if (message && !message.platform_message_id && data.platform_message_id) message.platform_message_id = data.platform_message_id;

      setTimeout(() => {
        if (!data.message_id || !message) {
          this.checkIfScrollAtBottom();
          const shouldScroll = data.origin != 'customer' || this.wasScrollAtBottom;

          this.messages.push(data);
          this.rendered_messages.push(data);
          this.last_read_message_index = this.messages.findLastIndex(m => m.status >= 4);
          this.typing = false;

          if (!shouldScroll) return this.newMessagesCount++;

          this.$nextTick(() => {
            this.scrollMessagesToBottom('smooth');
          });
        }
      }, delay);
    },

    scrollMessagesToBottom(behavior = 'smooth') {
      const dialogElement = this.$refs.dialogRef;

      if (dialogElement) {
        setTimeout(() => {
          dialogElement.scrollTo({ top: dialogElement.scrollHeight + 1000, behavior });
        }, 30);
      }
    },

    checkIfScrollAtBottom() {
      const dialogElement = this.$refs.dialogRef;
      if (!dialogElement) return;

      const scrollTop = dialogElement.scrollTop;
      const scrollHeight = dialogElement.scrollHeight;
      const clientHeight = dialogElement.clientHeight;
      
      // Considera que está no final se estiver a 50px do final
      this.wasScrollAtBottom = scrollTop + clientHeight >= scrollHeight - 50;
      if (this.wasScrollAtBottom) this.newMessagesCount = 0;
    },

    handleMessagesContainerResize() {
      // Só rolar se estava no final E se há uma conversa selecionada
      if (this.wasScrollAtBottom && this.selectedConversation?._id) {
        this.$nextTick(() => {
          this.scrollMessagesToBottom('instant');
        });
      }
    },

    setMessagesRead(message_id) {
      const message_index = this.messages.findIndex(m => m.platform_message_id == message_id);

      if (this.messages[message_index]) {
        this.messages[message_index].status = 4;
        if (message_index > this.last_read_message_index) this.last_read_message_index = message_index;
        this.$forceUpdate();
      }
    },

    loadMoreMessages() {
      this.rendered_messages = this.messages.slice(-1 * (this.rendered_messages.length + 25));

      this.$nextTick(() => {
        const element = document.getElementById(`message_25`);
        if (element) element.scrollIntoView({ behavior: "instant", block: "start" });
      })
    },

    async getMessages(conversation) {
      if (this.selectedConversation && this.selectedConversation._id != conversation._id) {
        this.text = "";
        this.clipboardImage = this.fileClipboardImage = null;
        this.replyingMessage = null;
        this.messages = [];
        this.rendered_messages = [];
        
        this.cleanupScrollObservers();
      }

      if (this.selectedConversation && this.selectedConversation._id == conversation._id) {
        if (!this.showConversation) this.showConversation = true;
        return;
      }

      this.typing = false;
      this.selectedConversation = conversation;
      this.showConversation = true;
      const resp = await Api.getMessagesByConversation(conversation._id);

      if (!resp.error && resp.message) {
        this.messages = resp.message;
        this.rendered_messages = this.messages.slice(-25);
        this.last_read_message_index = this.messages.findLastIndex(m => m.status >= 4);

        setTimeout(() => {
          this.scrollMessagesToBottom('instant');
          
          this.setupScrollObservers();
        }, 50);
      }
    },

    setupScrollObservers() {
      if (this.resizeObserver) return;
      
      this.$nextTick(() => {
        const dialogElement = this.$refs.dialogRef;
        if (dialogElement) {
          this.resizeObserver = new ResizeObserver(() => {
            this.handleMessagesContainerResize();
          });
          this.resizeObserver.observe(dialogElement);
          
          dialogElement.addEventListener('scroll', this.checkIfScrollAtBottom, { passive: true });
        }
      });
    },

    cleanupScrollObservers() {
      if (this.resizeObserver) {
        this.resizeObserver.disconnect();
        this.resizeObserver = null;
      }
      
      const dialogElement = this.$refs.dialogRef;
      if (dialogElement) {
        dialogElement.removeEventListener('scroll', this.checkIfScrollAtBottom);
      }
      
      this.wasScrollAtBottom = false;
      this.newMessagesCount = 0;
    },

    async finishConversation(conversation) {
      const message = `${this.currentUser.name} finalizou essa conversa.`;
      Api.createSystemMessage({ conversation_id: this.selectedConversation._id, message: message });

      const resp = await Api.finishConversation(conversation._id);

      if (!resp.error && resp.message) {
        const conversation_index = this.findConversationIndex(conversation._id.toString());
        if (conversation_index != -1) this.objects.splice(conversation_index, 1);

        this.selectedConversation = {};
        this.showConversation = false;
        this.messages = [];
        this.rendered_messages = [];
      }
    },

    async setManual(conversation) {
      const resp = await Api.setConversationManual(conversation._id);

      if (!resp.error && resp.message) {
        conversation.is_manual = true;

        const message = `${this.currentUser.name} entrou manualmente nessa conversa.`;
        await Api.createSystemMessage({ conversation_id: this.selectedConversation._id, message: message });

        this.selectedConversation = null;
        this.getMessages(conversation);
      }
    },

    hasValidAutoFollowUp(conversation) {
      const conversation_type = conversation.is_manual ? 'human' : conversation.chatbot_type;
      if (this.auto_follow_up && this.auto_follow_up?.enabled && this.auto_follow_up?.types.includes(conversation_type) && conversation?.auto_follow_up) return true;
      return false;
    },

    transferDepartment() {
      if (!this.transfer_department) return emitToastr("error", "É necessário selecionar um departamento  antes de transferir");
      const message = `${this.currentUser.name} transferiu o departamento de ${this.selectedConversation.department?.name} para ${this.transfer_department?.name}.`;
      Api.createSystemMessage({ conversation_id: this.selectedConversation._id, message: message });
      this.selectedConversation.department = this.transfer_department;
      if (this.selectedConversation?.last_message?.created) this.selectedConversation.last_message.created = new Date();
      this.transfer_department = null;
      this.changeConversationData();
    },

    async changeConversationData() {
      const resp = await Api.changeConversationData(this.selectedConversation);
      if (!resp.error) {
        emitToastr("success", "Conversa atualizada");
        this.selectedConversation = {};
        this.messages = [];
        this.rendered_messages = [];
        this.showConversation = false;
      }
    },

    async transferToFlow() {
      if (!this.transfer_flow) return emitToastr("error", "É necessário selecionar um fluxo antes de transferir");
      this.selectedConversation.flow = this.transfer_flow;
      this.selectedConversation.chatbot_type = 'flow_chatbot';
      this.selectedConversation.is_manual = false;
      this.selectedConversation.start_flow = true;
      this.selectedConversation.last_flow_context = "";
      delete this.selectedConversation.chatbot;

      const resp = await Api.changeConversationData(this.selectedConversation);
      if (!resp.error) {
        emitToastr("success", "Conversa atualizada");
        this.transfer_flow = null;
      }
    },

    async transferToChatbot() {
      if (!this.selectedConversation.chatbot) return emitToastr("error", "É necessário selecionar um chatbot antes de transferir");
      this.selectedConversation.chatbot_type = 'chatbot';
      this.selectedConversation.is_manual = false;
      this.selectedConversation.last_flow_context = "";
      delete this.selectedConversation.flow;

      const resp = await Api.changeConversationData(this.selectedConversation);
      if (!resp.error) {
        emitToastr("success", "Conversa atualizada");
      }
    },

    openTransferDialog() {
      this.transfer_flow = this.selectedConversation.flow || null;
      this.transferDialog = true;
    },

    transferConversation() {
      if (this.transferType == 'chatbot') this.transferToChatbot();
      if (this.transferType == 'flow') this.transferToFlow();
      if (this.transferType == 'department') this.transferDepartment();
      this.transferDialog = false;
    },

    async changeContactTags() {
      const resp = await Api.changeContactTags(this.selectedConversation.contact, this.selectedConversation._id);
      if (!resp.error) emitToastr("success", "Tags atualizadas");
    },

    applyRouteFilter({ situation, type, chip }) {
      let applied = false;

      if (situation) {
        const conversation_situation = this.conversation_situations.find(s => s.id === situation);
        if (conversation_situation) {
          this.pre_filter.situation = conversation_situation;
          applied = true;
        }
      }

      if (type) {
        const conversation_type = this.types.find(t => t.id === type);
        if (conversation_type) {
          this.pre_filter.types = [conversation_type];
          applied = true;
        }
      }

      if (chip) {
        const selected_chip = this.allowed_all_chips.find(c => c._id.toString() === chip.toString());
        if (selected_chip) {
          this.pre_filter.chips = [selected_chip];
          applied = true;
        }
      }

      if (!applied) return;

      this.can_clear = true;
      this.buildFilter();
    },

    clearFilters() {
      this.pre_filter = {
        text: '', changed: false, tags: [], departments: [], chips: [],
        types: [
          { name: 'Chatbot', id: 'chatbot', icon: 'mdi-robot-outline' },
          { name: 'Humano', id: 'human', icon: 'mdi-face-agent' }
        ],
        situation: 'all',
        date: []
      };
      this.can_clear = false;
      this.buildFilter();
      //NOTE: OK
      this.getConversations(this.options);
      this.filter_sheet = false;
    },

    applyFilters() {
      this.selectedConversation = {};
      this.messages = [];
      this.rendered_messages = [];
      this.can_clear = true;
      this.buildFilter();
      //NOTE: OK
      this.getConversations(this.options);
      this.filter_sheet = false;
    },

    applyDateFilter() {
      this.$refs.menuDate.save(this.pre_filter.date);
      this.menuDate = false;
    },

    clearDate() {
      this.pre_filter.date = [];
      this.$refs.menuDate.save(this.pre_filter.date);
      this.menuDate = false;
    },

    openFile(url) {
      window.open(url, "_blank");
    },

    async checkPhone() {
      this.new_conversation_jid = false;
      this.loading = true;
      const resp = await Api.checkPhone(this.country_code + this.new_conversation_phone, this.new_conversation_chip);
      this.loading = false;

      if (!resp.error && resp.message) {
        this.new_conversation_jid = resp.message;
        this.startNewConversation();
      }

    },

    async startNewConversationDialog() {
      this.new_contact = null;
      this.contacts = [];
      this.new_conversation_contact_type = 'existing';
      this.new_conversation_phone = '';
      this.new_conversation_jid = false;
      this.new_conversation_template = null;
      this.newConversationDialog = true
    },

    async startNewConversation() {

      if (this.new_conversation_contact_type == 'new' && !this.new_conversation_jid && !this.new_conversation_chip.official) {
        this.checkPhone();
        return;
      }

      if (this.new_conversation_chip.official) {
        if (!this.new_conversation_template) return emitToastr('error', 'Selecione um template de mensagem');
        if (!this.new_conversation_template.valid) return emitToastr('error', 'Preencha o valor de todas as variáveis e a mídia do template');

        this.new_conversation_jid = normalizePhone(this.country_code, this.new_conversation_phone);
      }

      const channel_contact_id = this.new_conversation_contact_type == 'new' ? this.new_conversation_jid : this.new_contact.channel_contact_id;

      this.loading = true;
      const resp = await Api.startNewConversation(channel_contact_id, this.new_conversation_chip, this.new_conversation_department, this.new_conversation_template?.template, this.new_conversation_template?.template_components);
      this.loading = false;

      if (!resp.error) this.newConversationDialog = false;
    },

    openMedias() {
      this.dialogMedia = true;
    },

    openRecording() {
      this.dialogRecording = true;
    },

    updateMedias(message) {
      if (message.type == 'delete') {
        const i = this.medias.findIndex(m => m._id.toString() == message.media_id);
        if (i != -1) this.medias.splice(i, 1);
      }
      else {
        this.medias.push(message);
      }
    },

    async sendMedia(media) {
      this.dialogMedia = false;
      this.sendMessage(media);
    },

    async deleteMessage() {
      const resp = await Api.deleteConversationMessage(this.selectedChatItem.platform_message_id, this.selectedConversation.contact?.phone, this.selectedConversation.chip?._id);
      if (!resp.error && resp.message == 'ok') {
        this.selectedChatItem.deleted = true;
        this.$forceUpdate();
      }
    },

    showImage(media_url) {
      this.media_url = media_url;
      this.imageViewerDialog = true;
    },

    openContact(contact_id) {
      this.selectedContact = contact_id;
      this.contactDrawer = true;
    },

    openUrl(url) {
      window.open(url, "_blank");
    },

    getItemText(item) {
      return item.override_name || item.name;
    },

    async toggleNotificationSoundConfig() {
      let user_config = this.currentUser.config || { disable_notification_sound: false };
      user_config.disable_notification_sound = !user_config.disable_notification_sound;
      await this.$api.updateUserConfig(user_config);
      emitToastr("success", "Configuração alterada.");
    },

    async toggleUserSignature() {
      const currentValue = this.currentUser.config?.user_signature || false;
      const newConfig = {
        ...this.currentUser.config,
        user_signature: !currentValue,
      };
      this.currentUser.config = newConfig;
      await this.$api.updateUserConfig(newConfig);
      emitToastr("success", "Configuração alterada.");
    },

    async searchContacts(val) {
      this.loading = true;
      if (timeout) clearTimeout(timeout);

      timeout = setTimeout(async () => {
        this.options.page = 1;
        this.loading = true;
        const resp = await Api.getContactsByUser({ itemsPerPage: 10, query: val });
        if (!resp.error && resp.message) {
          this.contacts = resp.message.data;
          this.loading = false;
        }
        this.loading = false;
      }, 250);
    },

    async summarizeMessages() {
      try {
        if (this.summary_ai_loading) emitToastr("error", "Resumo em processamento. Por favor aguarde...");

        // eslint-disable-next-line
        if (tianji) tianji.track('ai_summary', {});

        let msgs = this.messages.filter(m => m.type === 'text' || m.type === 'audio');
        if (msgs.length > 30) msgs = msgs.slice(-30);

        let simplifiedConversation = '';

        msgs.forEach(m => {
          simplifiedConversation += `${m.origin === 'customer' ? 'Contato' : this.users[m.user] || 'Chatbot'}: ${m.message}\n`
        });

        this.summary_ai_loading = true;
        const resp = await Api.summarizeMessages(this.selectedConversation._id, simplifiedConversation);
        this.summary_ai_loading = false;

        if (!resp.error && resp.message) {
          emitToastr("success", `Conversa resumida. Saldo mensal disponível para novos resumos: ${resp.balance}`);
        }
      }
      catch (err) {
        emitToastr("error", "Erro ao resumir mensagens");
      }
    },

    async createAIFollowUp() {
      try {
        if (this.follow_up_ai_loading) emitToastr("error", "Follow-up em processamento. Por favor aguarde...");

        // eslint-disable-next-line
        if (tianji) tianji.track('ai_follow_up', {});

        let msgs = this.messages.filter(m => m.type === 'text' || m.type === 'audio');
        if (msgs.length > 15) msgs = msgs.slice(-15);

        let simplifiedConversation = '';

        msgs.forEach(m => {
          simplifiedConversation += `${m.origin === 'customer' ? 'Contato' : this.users[m.user] || 'Chatbot'}: ${m.message}\n`
        });

        this.follow_up_ai_loading = true;
        const resp = await Api.createAIFollowUp(this.selectedConversation._id, simplifiedConversation);
        this.follow_up_ai_loading = false;

        if (!resp.error && resp.message) {
          emitToastr("success", `Follow-up criado. Saldo mensal disponível para novos follow-ups: ${resp.balance}`);
          this.text = resp.message.follow_up;
        }
      }
      catch (err) {
        emitToastr("error", "Erro ao resumir mensagens");
      }
    },

    async createAIReply() {
      try {
        if (this.reply_ai_loading) emitToastr("error", "Resposta em processamento. Por favor aguarde...");

        // eslint-disable-next-line
        if (tianji) tianji.track('ai_reply', {});

        let msgs = this.messages.filter(m => m.type === 'text' || m.type === 'audio');
        if (msgs.length > 15) msgs = msgs.slice(-15);

        let simplifiedConversation = '';

        msgs.forEach(m => {
          simplifiedConversation += `${m.origin === 'customer' ? 'Contato' : this.users[m.user] || 'Chatbot'}: ${m.message}\n`
        });

        this.reply_ai_loading = true;
        const resp = await Api.createAIReply(this.selectedConversation._id, simplifiedConversation);
        this.reply_ai_loading = false;

        if (!resp.error && resp.message) {
          emitToastr("success", `Resposta sugerida. Saldo mensal disponível para novas sugestões: ${resp.balance}`);
          this.text = resp.message.reply;
        }
      }
      catch (err) {
        this.reply_ai_loading = false;
        emitToastr("error", "Erro ao sugerir resposta");
      }
    },
    handlePaste(event) {
      const item = event.clipboardData.items[0];
      if (item && item.type.startsWith("image")) {
        this.fileClipboardImage = item.getAsFile();
        const reader = new FileReader();

        reader.onload = (e) => {
          this.clipboardImage = e.target.result;
        };

        reader.readAsDataURL(this.fileClipboardImage);
      }
    },
    async sendClipboardImage(file) {
      if (this.isSendingClipboardImage) return;

      this.isSendingClipboardImage = true;
      const resp = await Api.uploadFile(file, "image", "", true);

      if (!resp.error && resp.message) {
        this.clipboardImage = this.fileClipboardImage = null;
        this.sendMedia(resp.message);
        this.isSendingClipboardImage = false;
      }
      else {
        emitToastr("error", "Erro ao enviar imagem.");
        this.isSendingClipboardImage = false;
      }
    },
    clearClipboardImage() {
      this.clipboardImage = null;
      this.fileClipboardImage = null;
    },

    updateOpportunityField({ field, value }) {
      if (this.newOpportunity) {
        this.newOpportunity[field] = value;
      }
    },

    updateOpportunityStep(value) {
      if (this.newOpportunity) {
        this.newOpportunity.step = value;
      }
    },
    
    async openCreateOpportunityFromConversation() {
      if (!this.selectedConversation?.contact) return emitToastr('error', 'Não foi possível identificar o contato desta conversa');

      if (this.funnels.length === 0) {
        const response = await Api.getFunnelsByAccount();
        if (!response.error && response.message) {
          this.funnels = response.message || [];
        }
      }

      if (this.users_list.length === 0) {
        const resp = await Api.getTeamUsers();
        if (!resp.error && resp.message) {
          this.users_list = resp.message;
        }
      }

      this.newOpportunity = {
        title: `Oportunidade - ${this.selectedConversation.contact?.override_name || this.selectedConversation.contact?.name || 'Contato'}`,
        description: '',
        value: '',
        contact: this.selectedConversation.contact?._id,
        assigned_user: this.currentUser._id,
        funnel: this.funnels[0]?._id || null,
        step: null
      };

      if (this.newOpportunity.funnel) {
        await this.loadFunnelSteps();
      }

      this.createOpportunityDialog = true;
    },

    async loadFunnelSteps() {
      if (!this.newOpportunity.funnel) {
        this.opportunitySteps = [];
        this.newOpportunity.step = null;
        return;
      }

      const response = await Api.getStepsByFunnel(this.newOpportunity.funnel);
      if (response && !response.error) {
        this.opportunitySteps = response.message || [];
        this.newOpportunity.step = this.opportunitySteps[0]?._id || null;
      }
    },

    async createOpportunityFromConversation() {
      if (!this.newOpportunity.funnel || !this.newOpportunity.step) return emitToastr('error', 'Selecione um funil e uma etapa');

      this.savingOpportunity = true;

      try {
        const opportunityData = {
          ...this.newOpportunity,
          value: formatMaskedCurrencyToNumber(this.newOpportunity.value)
        };

        const response = await Api.createOrUpdateOpportunity(opportunityData);

        if (response && response.error) return emitToastr('error', response.message);

        const funnelName = this.funnels.find(f => f._id === this.newOpportunity.funnel)?.name;
        const message = `${this.currentUser.name} criou uma oportunidade no funil "${funnelName}" a partir desta conversa.`;
        await Api.createSystemMessage({ conversation_id: this.selectedConversation._id, message: message });

        emitToastr('success', 'Oportunidade criada com sucesso!');
        this.createOpportunityDialog = false;
        this.newOpportunity = null;
      } catch (error) {
        emitToastr('error', 'Erro ao criar oportunidade');
      } finally {
        this.savingOpportunity = false;
      }
    },

    async openSendTemplateDialog() {
      this.selectedTemplate = null;
      
      // Buscar templates do chip da conversa
      if (this.selectedConversation.chip) {
        const chip = this.chips.find(c => c._id === this.selectedConversation.chip._id);
        if (chip && chip.waba) {
          const templates = await Api.getTemplateMessages(chip.waba);
          if (!templates.error && templates.message) {
            this.templates = templates.message.filter(t => t.status === 'APPROVED');
          }
        }
      }
      
      this.sendTemplateDialog = true;
    },

    async sendTemplateToContact() {
      if (!this.selectedTemplate) return emitToastr('error', 'Selecione um template');
      if (!this.selectedTemplate.valid) return emitToastr('error', 'Preencha o valor de todas as variáveis e a mídia do template');

      this.sendTemplateLoading = true;

      try {
        const resp = await Api.sendTemplateToConversation(this.selectedConversation._id, this.selectedTemplate.template, this.selectedTemplate.template_components);

        if (resp && resp.error) {
          emitToastr('error', resp.message || 'Erro ao enviar template');
        } else {
          emitToastr('success', 'Template enviado com sucesso!');
          this.sendTemplateDialog = false;
          this.selectedTemplate = null;
        }
      } catch (error) {
        emitToastr('error', 'Erro ao enviar template');
      } finally {
        this.sendTemplateLoading = false;
      }
    },
  },
};
</script>

<style scoped lang="scss">
.custom-page {
  height: auto;
  max-height: 100%;
  overflow: hidden;
  padding: 0 !important;
}

.conversation-list {
  height: calc(100vh - 200px);
  overflow-y: scroll;
  scrollbar-width: thin !important;
  scrollbar-color: rgba(206, 206, 206, 0.322) transparent !important;
}

.v-scroll {
  height: calc(100vh - 130px);
  scrollbar-width: thin !important;
  scrollbar-color: rgba(100, 100, 100, 0.6) transparent !important;
}

.container-name-date {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: center;
  overflow: hidden;
  gap: 4px;
}

#conversation-contact-name {
  flex: 0 1 auto;
  font-weight: 500;
}

#date-last-message {
  flex: 1 0 auto;
  font-size: 0.75rem;
  text-align: end;
}

.filter-bar {
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: space-between;
}

.filter-item {
  font-size: 14px;
}

.conversation-container {
  background-color: var(--v-gray75-base) !important;
  position: relative;
  height: calc(100vh - 250px);
  min-height: 0;
  overflow: hidden;
  scrollbar-width: thin !important;
  scrollbar-color: rgba(206, 206, 206, 0.322) transparent !important;
  display: flex;
  flex-direction: column;
}

.contact-container {
  display: flex;
  flex-direction: row;
  align-items: center;
  width: 100%;
}

.contact-info {
  color: var(--v-gray600-base) !important;
  display: flex;
  flex-direction: column;
  margin-left: 14px;
}

.contact-name {
  font-size: 18px;
  font-weight: 600;
}

.contact-phone {
  font-size: 14px;
}

.messages-background {
  background-color: var(--v-gray75-base) !important;
  border-radius: 10px;
  border: 1px solid var(--v-gray200-base);
  margin: 5px;
  margin-top: 15px;
}

.messages-app-bar {
  display: flex;
  flex-direction: row;
  align-items: center;
  border-radius: 8px;
  background-color: white;
  margin-bottom: 4px;
}

.new-messages-btn {
  position: sticky;
  bottom: 0;
  align-self: center;
}

.messages-container {
  background-color: var(--v-gray75-base) !important;
  display: flex;
  flex-direction: column;
  overflow-y: scroll;
  flex-grow: 1;
  flex-shrink: 1;
  min-height: 0;
  font-size: 14px;
  scrollbar-width: thin !important;
  scrollbar-color: rgba(206, 206, 206, 0.322) transparent !important;
}

.container-chat-item {
  display: flex;
  flex-direction: column;
  max-width: 400px;
}

.container-chatbot-message {
  align-self: flex-end;
}

.container-customer-message {
  align-self: flex-start;
}

.internal-signature {
  color: var(--v-gray400-base);
  font-style: italic;
  font-size: 0.7rem;
  text-align: end;
  margin-bottom: 4px;
}

.chat-item {
  background-color: white;
  border: 1px solid var(--v-gray100-base);
  color: var(--v-gray600-base);
  max-width: 400px;
  padding: 8px;
  padding-bottom: 4px;
  margin-top: 8px;
  margin-bottom: 2px;
  border-radius: 12px;
  white-space: pre-line;
  word-wrap: break-word;
}

.chatbot-message {
  background-color: var(--v-green100-base);
  border: 1px solid var(--v-green200-base);
  font-weight: 500;
  color: var(--v-green900-base);
  word-break: break-word;
}

.customer-message {
  background-color: #ffffff;
  font-weight: 500;
  word-break: break-word;
}

.deleted-message {
  background-color: #ffdfdf !important;
  border: 1px solid #ffc9c9
}

.summary-message {
  background-color: #f7cdff !important;
  border: solid 1px #ba68c8 !important
}

.system-message {
  background-color: #fffed9 !important;
  border: solid 1px #f1e89a !important
}

.message-time {
  text-align: right;
  font-size: 11px;
}

.command-bar {
  height: auto;
  max-height: 250px;
  display: flex;
  background-color: white;
  border: 1px solid var(--v-gray50-base);
  border-radius: 12px;
  flex-direction: column;
  flex-wrap: nowrap;
  align-items: stretch;
  justify-content: center;
  width: 100%;
  width: -moz-available;
  width: -webkit-fill-available;
  width: fill-available;
  flex-shrink: 0;
}

.one-line {
  display: inline-block;
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
}

.video-container {
  width: 100%;
  max-height: 50vh;
  border-radius: 6px;
}

.reply-container {
  padding: 5px;
  background-color: rgba(0, 0, 0, 0.05);
  border-radius: 4px;
  font-style: italic;
  font-size: 12px;
}

.reply-preview {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 8px 12px;
  background-color: var(--v-gray100-base);
  border-left: 3px solid var(--v-primary-base);
  border-radius: 4px;
  margin: 12px 12px 0 12px;
  width: calc(100% - 32px);
}

.slide-up-enter-active,
.slide-up-leave-active {
  transition: all 0.3s ease;
}

.slide-up-enter,
.slide-up-leave-to {
  transform: translateY(20px);
  opacity: 0;
}

.reply-preview-content {
  display: flex;
  align-items: flex-start;
  flex: 1;
  overflow: hidden;
}

.reply-preview-info {
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.reply-preview-origin {
  font-size: 12px;
  font-weight: 600;
  color: var(--v-primary-base);
}

.reply-preview-message {
  font-size: 13px;
  color: var(--v-gray600-base);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 90vw;
}

::v-deep .v-dialog {
  scrollbar-width: thin !important;
  scrollbar-color: rgba(206, 206, 206, 0.322) transparent !important;
}

#exampleInputEmoji {
  position: absolute;
  transform: translateY(-200px);
  z-index: 999;
}

::v-deep .refMenuClipboardImage textarea {
  max-height: 150px;
  overflow-y: auto;
}

@media only screen and (max-width: 960px) {
  .messages-background {
    margin: 0px;
  }

  .conversation-container {
    height: calc(100vh - 120px);
  }

  .conversation-list {
    height: calc(100vh - 110px);
  }

  .contact-info {
    width: auto;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .contact-name {
    font-size: 15px !important;
    overflow: hidden;
    text-overflow: ellipsis;
  }
}

.container-transfer {
  display: flex;
  flex-direction: column;
  gap: 1.1rem;
}

/* Dark mode */
.theme--dark .chat-item {
  border: 1px solid;
  color: #e5e7eb;
}

.theme--dark .customer-message {
  background-color: var(--v-gray200-base);
  border: 1px solid rgba(139, 139, 139, 0.4);
}

.theme--dark .chatbot-message {
  background-color: rgba(16, 185, 129, 0.3);
  border: 1px solid rgba(16, 185, 129, 0.4);
}

.theme--dark .deleted-message {
  background-color: rgba(239, 68, 68, 0.2) !important;
  border: 1px solid rgba(239, 68, 68, 0.4) !important;
}

.theme--dark .summary-message {
  background-color: rgba(186, 104, 200, 0.2) !important;
  border: solid 1px rgba(186, 104, 200, 0.4) !important;
}

.theme--dark .system-message {
  background-color: rgba(234, 178, 8, 0.3) !important;
  border: solid 1px rgba(234, 179, 8, 0.4) !important;
}

.theme--dark .command-bar {
  background-color: var(--v-gray50-base);
  border-color: var(--v-gray200-base);
}

.theme--dark .messages-app-bar {
  background-color: var(--v-gray50-base);
}

.theme--dark .reply-container {
  background-color: rgba(0, 0, 0, 0.2);
}

.theme--dark .reply-preview {
  background-color: var(--v-gray200-base);
}

.theme--dark .reply-preview-message {
  color: var(--v-gray400-base);
}

.theme--dark .internal-signature {
  color: var(--v-gray500-base);
}
</style>